export default __webpack_public_path__ + "static/media/casaduana_Registrate.ffc4932c.svg";